import { IEnergyUsage } from "@/models/energyUsage/energyUsage.types"
import { EnergyUsageFuelType } from "@/api/backofficeRest/generated/model"
import { HealthCheckInfo, UsageType } from "./getAccountHealthChecks"
import { Status } from "@/types/Status"

const FUEL_TYPE_BY_METERPOINT_TYPE: Record<string, EnergyUsageFuelType> = {
  MPAN: EnergyUsageFuelType.ELECTRICITY,
  MPRN: EnergyUsageFuelType.GAS,
}

export function checkEnergyUsageForMeterpoint(
  dailyUsage: IEnergyUsage[],
  hhUsage: IEnergyUsage[],
  meterpointType: string,
): HealthCheckInfo[] {
  const fuelType = FUEL_TYPE_BY_METERPOINT_TYPE[meterpointType]
  const mpDaily = dailyUsage.filter((u) => u.fuelType === fuelType)
  const mpHh = hhUsage.filter((u) => u.fuelType === fuelType)

  const hasDaily = mpDaily.some((u) => u.hasValues)
  const hasHh = mpHh.some((u) => u.hasValues)

  return [
    {
      status: hasDaily
        ? new Status("normal", "Daily usage data available")
        : new Status("caution", "No recent daily usage data"),
      title: "Daily usage",
      type: UsageType.Daily,
    },
    {
      status: hasHh
        ? new Status("normal", "Half-hourly usage data available")
        : new Status("caution", "No recent half-hourly usage data"),
      title: "Half-hourly usage",
      type: UsageType.HalfHourly,
    },
  ]
}
